import { useEffect } from 'react';
import { useAppState, useDispatch, useBrandId } from 'AppProvider';
import { z } from 'zod';
import { getCurrencyFromCode } from 'utils';
import { STATUS_SUCCESS, STATUS_PENDING } from 'types/app';
import { Currency, CurrencySymbol } from '@kouto/types';
import { fetchBrandSettings } from 'actions/brand';

export const CurrencyObjectSchema = z.object({
  code: z.nativeEnum(Currency),
  fullName: z.string(),
  currencySymbol: z.nativeEnum(CurrencySymbol),
});

const DEFAULT_CURRENCY_RAW = getCurrencyFromCode(Currency.USD);
const DEFAULT_CURRENCY = CurrencyObjectSchema.parse(DEFAULT_CURRENCY_RAW);

export const useBrandCurrency = () => {
  const dispatch = useDispatch();
  const brandId = useBrandId();
  const { fetchSettingsStatus, ...brand } = useAppState(
    (app: Record<string, unknown>) => app.brand,
  );

  useEffect(() => {
    if (
      fetchSettingsStatus !== STATUS_SUCCESS &&
      fetchSettingsStatus !== STATUS_PENDING &&
      brandId
    ) {
      dispatch(fetchBrandSettings(brandId));
    }
  }, [fetchSettingsStatus, brandId, dispatch]);

  if (fetchSettingsStatus === STATUS_SUCCESS) {
    const data = getCurrencyFromCode(brand.settings?.currency);
    const parsedCurrency = CurrencyObjectSchema.safeParse(data);
    if (parsedCurrency.success) {
      return parsedCurrency.data;
    }
  }

  console.warn(
    'Returning DEFAULT_CURRENCY, could not pull currency from brand settings',
    DEFAULT_CURRENCY,
  );

  return DEFAULT_CURRENCY;
};
